<template>
  <div id="SearchForm" class="search-form">
    <el-form class="form-part" :size="configs.size" inline :model="searchForm" @submit.native.prevent>
      <el-form-item v-for="item in formItemsInfo" :key="item.key" :label="item.label" :style="configs.itemStyle">
        <el-input
          v-if="item.type === 'input'"
          v-model="item.value"
          type="text"
          :style="item.style || {width: '140px'}"
          :placeholder="item.placeholder || '请输入'"
          :disabled="item.disable"
          clearable
          @change="()=>{handleSearch(item)}"
        />
        <el-select
          v-if="item.type === 'select'"
          v-model="item.value"
          :style="item.style || {width: '140px'}"
          :placeholder="item.placeholder || '全部'"
          :disabled="item.disable"
          clearable
          :filterable="item.filterable"
          @change="()=>{handleSearch(item)}"
        >
          <el-option
            v-for="(opt, index) in item.selectOpts"
            :key="index"
            :label="opt.label"
            :value="opt.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="showKeyword" class="keyword-part" :style="configs.itemStyle">
      <el-input
        v-model="searchForm[keyword]"
        :size="configs.size"
        class="keyword-input"
        clearable
        :placeholder="keywordPlaceholder"
        @change="()=>{handleSearch({key: keyword, value: searchForm[keyword]})}"
      >
        <i slot="append" class="el-icon-search" />
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GjwSearchForm',
  props: {
    // {
    //   key: 接口中的定义字段名，
    //   label: 页面显示名，
    //   type: 类型, 包括 input, select, 后续可扩展radio，checkbox, date等
    //   placeholder： 默认‘请输入’， ‘请选择’，
    //   disable: boolean,
    //   selectOpts: [], type为select时，所有选项，固定为：{label：‘’， value: ''}
    // }
    formItems: {
      type: Array,
      default() {
        return []
      },
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    showKeyword: {
      type: Boolean,
      default: true
    },
    keyword: {
      type: String,
      default: 'keyword'
    },
    keywordPlaceholder: {
      type: String,
      default: '请输入关键字'
    }
  },
  data() {
    return {
      // 表单项
      formItemsInfo: this.formItems,
      // 搜索数据值
      searchForm: {}
    }
  },
  computed: {
    configs() {
      const defaultConfig = {
        size: 'small',
        itemStyle: 'margin-bottom: 10px;',
      }
      return { ...defaultConfig, ...this.config }
    }
  },
  watch: {
    formItems(newVal) {
      this.formItemsInfo = newVal
    }
  },
  methods: {
    reset() {
      this.searchForm = {}
      this.formItemsInfo = this.formItemsInfo.map((item) => {
        return { ...item, value: '' }
      })
    },
    handleSearch(item) {
      this.searchForm[item.key] = item.value
      this.$emit('search', this.searchForm)
    }
  }
}
</script>

<style lang="less" scoped>
.search-form {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .keyword-part{
    flex: 0 0 220px;
  }
}
.keyword-input{
  /deep/ .el-input__suffix{
    display: flex;
    align-items: center;
  }
}
</style>
